import { useEffect, useState } from "react";
import api from "@/lib/api";
import { toast } from "sonner";
import { NotePencil, Plus } from "@phosphor-icons/react";
import { Button } from "@/components/ui/button";

const STATUS = { primita: "Primită", negociere: "În negociere", acceptata: "Acceptată" };
const COLOR = { primita: "text-amber-300", negociere: "text-sky-300", acceptata: "text-emerald-300" };

export default function SiteNotesPanel() {
  const [rows, setRows] = useState([]);
  const [f, setF] = useState({ project_code: "", beneficiary: "", description: "" });

  const load = () => api.get("/site-notes").then((r) => setRows(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);

  const add = async () => {
    if (!f.description.trim()) { toast.error("Adaugă o descriere"); return; }
    try { await api.post("/site-notes", f); setF({ project_code: "", beneficiary: "", description: "" }); load(); toast.success("Notă de șantier adăugată"); }
    catch (e) { toast.error("Eroare la adăugare"); }
  };
  const setStatus = async (id, status) => { await api.patch(`/site-notes/${id}`, { status }); load(); };

  return (
    <div className="mt-6" data-testid="site-notes-panel">
      <h2 className="flex items-center gap-2 text-sm font-semibold"><NotePencil size={18} weight="bold" /> Note de șantier</h2>
      <p className="text-xs text-muted-foreground">Primite de la Producție; negociate cu beneficiarul (primită → în negociere → acceptată).</p>

      <div className="mt-3 grid gap-2 sm:grid-cols-2 lg:grid-cols-4 rounded-xl border border-border bg-white/[0.02] p-3">
        <input data-testid="sn-project" placeholder="Cod proiect" value={f.project_code} onChange={(e) => setF({ ...f, project_code: e.target.value })} className="rounded-lg border border-border bg-background px-2 py-2 text-sm" />
        <input data-testid="sn-beneficiary" placeholder="Beneficiar" value={f.beneficiary} onChange={(e) => setF({ ...f, beneficiary: e.target.value })} className="rounded-lg border border-border bg-background px-2 py-2 text-sm" />
        <input data-testid="sn-desc" placeholder="Descriere notă" value={f.description} onChange={(e) => setF({ ...f, description: e.target.value })} className="rounded-lg border border-border bg-background px-2 py-2 text-sm" />
        <Button onClick={add} data-testid="sn-add" className="gap-1"><Plus size={16} /> Adaugă</Button>
      </div>

      <div className="mt-3 overflow-hidden rounded-xl border border-border">
        <table className="w-full text-sm">
          <thead className="bg-white/[0.02] text-xs uppercase text-muted-foreground"><tr>
            <th className="px-3 py-2 text-left">Proiect</th><th className="px-3 py-2 text-left">Beneficiar</th>
            <th className="px-3 py-2 text-left">Descriere</th><th className="px-3 py-2 text-left">Status</th>
          </tr></thead>
          <tbody className="divide-y divide-border">
            {rows.map((n) => (
              <tr key={n.id} data-testid={`sn-row-${n.id}`}>
                <td className="px-3 py-2">{n.project_code || "—"}</td>
                <td className="px-3 py-2">{n.beneficiary || "—"}</td>
                <td className="px-3 py-2 text-muted-foreground">{n.description}</td>
                <td className="px-3 py-2">
                  <select value={n.status} onChange={(e) => setStatus(n.id, e.target.value)} data-testid={`sn-status-${n.id}`} className={`rounded-md border border-border bg-background px-2 py-1 text-xs ${COLOR[n.status] || ""}`}>
                    {Object.entries(STATUS).map(([k, v]) => <option key={k} value={k}>{v}</option>)}
                  </select>
                </td>
              </tr>
            ))}
            {rows.length === 0 && <tr><td colSpan={4} className="px-3 py-4 text-center text-sm text-muted-foreground">Nicio notă de șantier momentan.</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}
